(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["t305-sample-trial"] && !Shopify.designMode) return;
  try {
    
function initT305SampleTrial(scope) {
  scope.querySelectorAll('[data-t305-trial]').forEach((root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const cleanup = [];
    root.t305Cleanup = cleanup;
    const lang = root.getAttribute('lang') || 'en';
    const reduceMotion = () => !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    
    const publish = (name, payload) => {
      try {
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish(name, payload);
        }
      } catch (error) {
        
      }
    };
    root.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      const cta = target.closest('[data-t305-cta]');
      if (cta && root.contains(cta)) {
        publish('t305:sample_cta', {cta_position: cta.getAttribute('data-t305-cta') || 'section', page_language: lang});
        return;
      }
      const help = target.closest('[data-t305-channel]');
      if (help && root.contains(help)) {
        publish('t305:sample_help', {channel: help.getAttribute('data-t305-channel') || 'other'});
        return;
      }
      const app = target.closest('[data-t305-app]');
      if (app && target.closest('button, a, [role="button"]') && !target.closest('dialog, [role="dialog"], [aria-modal="true"]')) {
        publish('t305:sample_cta', {cta_position: 'hero_upload', page_language: lang});
      }
    }, true);

    
    root.querySelectorAll('[data-t305-help]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const destination = link.getAttribute('href');
        const help = destination ? document.getElementById(destination.slice(1)) : null;
        if (!help || !root.contains(help)) return;
        event.preventDefault();
        help.open = true;
        help.scrollIntoView({block: 'start', behavior: 'auto'});
        help.querySelector('summary')?.focus({preventScroll: true});
      });
    });

    
    const upload = root.querySelector('[data-t305-upload]');
    if (upload) {
      let targetTimer = 0;
      let ringed = null;
      const clearRing = () => {
        if (ringed) ringed.classList.remove('t305-is-target');
        ringed = null;
      };
      cleanup.push(() => {
        window.clearTimeout(targetTimer);
        clearRing();
      });
      root.querySelectorAll('a[data-t305-cta]').forEach((link) => {
        const destination = link.getAttribute('href') || '';
        if (destination !== '#' + upload.id) return;
        link.addEventListener('click', (event) => {
          event.preventDefault();
          upload.scrollIntoView({block: 'center', behavior: reduceMotion() ? 'auto' : 'smooth'});
          const control = Array.from(upload.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]):not([type="hidden"]), [tabindex]:not([tabindex="-1"])'))
            .find((element) => element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden');
          if (control) control.focus({preventScroll: true});
          if (!control || document.activeElement !== control) {
            upload.setAttribute('tabindex', '-1');
            upload.focus({preventScroll: true});
          }
          clearRing();
          ringed = control && document.activeElement === control ? control : upload;
          ringed.classList.add('t305-is-target');
          window.clearTimeout(targetTimer);
          targetTimer = window.setTimeout(clearRing, 1800);
        });
      });
    }

    
    const sticky = root.querySelector('[data-t305-sticky]');
    const closing = root.querySelector('[data-t305-closing]');
    if (sticky && upload && 'IntersectionObserver' in window) {
      const state = {uploadVisible: true, closingReached: false, overlayOpen: false};
      const render = () => {
        sticky.classList.toggle('is-visible', !state.uploadVisible && !state.closingReached && !state.overlayOpen);
      };
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === upload) state.uploadVisible = entry.isIntersecting && entry.intersectionRatio >= 0.6;
          if (entry.target === closing) state.closingReached = entry.isIntersecting || entry.boundingClientRect.top < 0;
        });
        render();
      }, {rootMargin: '0px', threshold: [0, 0.6, 1]});
      observer.observe(upload);
      if (closing) observer.observe(closing);
      cleanup.push(() => observer.disconnect());

      
      const isShown = (element) => {
        if (sticky.contains(element)) return false;
        if (typeof element.checkVisibility === 'function') {
          if (!element.checkVisibility({checkOpacity: true, checkVisibilityCSS: true})) return false;
        } else {
          if (!element.getClientRects().length || element.closest('details:not([open])')) return false;
          const style = getComputedStyle(element);
          if (style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
        }
        const box = element.getBoundingClientRect();
        return box.width > 0 && box.height > 0;
      };
      const checkOverlay = () => {
        const dialogOpen = Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"]')).some(isShown);
        const locked = getComputedStyle(document.body).overflow === 'hidden' || getComputedStyle(document.documentElement).overflow === 'hidden';
        state.overlayOpen = dialogOpen || locked;
        render();
      };
      let queued = false;
      const queueCheck = () => {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(() => {
          queued = false;
          checkOverlay();
        });
      };
      const overlayObserver = new MutationObserver(queueCheck);
      overlayObserver.observe(document.body, {childList: true, attributes: true, attributeFilter: ['class', 'style']});
      overlayObserver.observe(document.documentElement, {attributes: true, attributeFilter: ['class', 'style']});
      overlayObserver.observe(upload, {childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'open', 'hidden', 'aria-hidden']});
      document.addEventListener('transitionend', queueCheck, true);
      document.addEventListener('toggle', queueCheck, true);
      document.addEventListener('click', queueCheck, true);
      cleanup.push(() => {
        overlayObserver.disconnect();
        document.removeEventListener('transitionend', queueCheck, true);
        document.removeEventListener('toggle', queueCheck, true);
        document.removeEventListener('click', queueCheck, true);
      });
      queueCheck();
    }
  });
}
initT305SampleTrial(document);
document.addEventListener('shopify:section:load', (event) => initT305SampleTrial(event.target));
document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('[data-t305-trial]').forEach((root) => {
    (root.t305Cleanup || []).forEach((stop) => stop());
  });
});

  } catch(e) { console.error(e); }
})();
})();
